export default (config = {}) => {
    return '<div class="_track wp-dark-mode-ignore"><span class="_thumb wp-dark-mode-ignore"></span></div>';
   };